import { assetPackIds } from "nemuru-components";
import { THEME_NAMES } from "./config";

export const upfTheme = {
  zendeskCustomerSupport: true,
  themeName: THEME_NAMES.upf,
  logoUrl: "https://cdn.nemuru.com/assets/logos/upf-logo.svg",
  palette: {
    primary: {
      main: "#353430",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#c8102e",
      contrastText: "#ffffff",
    },
    dark: {
      main: "#f4f4f4",
      contrastText: "#353430",
      accent: "#c8102e",
      imageBackgroundOpacity: 0.85,
    },
    text: {
      title: "#000",
      primary: "#353430",
      secondary: "#666",
    },
    status: {
      active: "#4ac687",
      approved: "#349a65",
      analysing: "#00529c",
      sent: "#00274a",
      cancelled: "#d8d8d8",
      denied: "#e81e26",
    },
    info: {
      main: "#36a3f7",
      contrastText: "#ffffff",
      light: "#E1F1FD",
    },
    warning: {
      main: "#f8cd51",
      contrastText: "#ffffff",
      light: "#fff6e7",
    },
    success: {
      main: "#479d38",
      contrastText: "#ffffff",
      light: "rgba(76, 205, 138,0.6)",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f2",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  assetPackDefsId: assetPackIds.OUTLINED,
  background: "#E9E9E9",
  customBorderRadius: {
    button: 3,
    paper: 3,
  },
  typography: {
    fontFamily: "Verdana,Geneva,sans-serif",
  },
};
